<template>
<div class="animated fadeIn">
        <b-card>
          <div slot="header">
            List Kategori <b-badge>{{data_kategori.length}}</b-badge>
                    <button class="btn btn-success btn-sm" style="margin:3px;"
                    @click="showmodalku('Tambah Data')">Add Data Kategori</button> 

          </div>
          <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ID Kategori</th>
                  <th>Nama Kategori</th>
                  <th>Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rowtkat,key) in data_kategori" :key="key">
                  <td>{{key+1}}</td>
                  <td><b style="color:blue;">{{rowtkat._id}}</b></td>
                  <td>{{rowtkat.nama}}</td>
                  <td>
                    <b-badge variant="success"  v-if="rowtkat.status=='Y'"> Aktif</b-badge>
                    <b-badge variant="danger"  v-if="rowtkat.status=='N'"> Tidak Aktif</b-badge>
                  </td>
                  <td  class="text-center">
                    <button class="btn btn-primary btn-sm" style="margin:3px;" @click="viewdata(rowtkat._id)">Edit Data</button> 
                    <button class="btn btn-danger btn-sm" style="margin:3px;" @click="deletedata(rowtkat._id)">Delete Data</button>
                    </td>
                </tr>
              </tbody>
            </table>
        </b-card>

  <!-- MODAL ADD DATA -->
    <b-modal ref="modal" size="md" hide-footer centered :title=this.modalstatus>
      <b-col md="12" sm="12">
          <b-row v-if="this.loadingpost==false&&this.modalstatus=='Ubah Data'">
            <b-col sm="12">
              <b-form-group>
                <label for="id">ID Kategori</label>
                <b-form-input type="text" v-model="readonly.id" readonly></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="name">Nama Kategori</label>
                <b-form-input type="text" v-model="kategori.nama" placeholder="Masukkan Nama Kategori"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
               <b-form-group >
                <label for="month1">Status Kategori</label>
                <select name="" class="form-control" v-model="kategori.status">
                  <option value="">Please select</option>
                  <option value="Y">Aktif</option>
                  <option value="N">Tidak Aktif</option>
                </select>
              </b-form-group>
            </b-col>
          </b-row>
      </b-col>
          <hr>
          
          <b-btn class="btn-info mr-1 float-right btn-sm" @click="addpost" v-if="this.loadingpost==false&&this.modalstatus=='Tambah Data'">Simpan Data</b-btn>
          <b-btn class="btn-info mr-1 float-right btn-sm" @click="updatepost" v-else-if="this.loadingpost==false&&this.modalstatus=='Ubah Data'">Update Data</b-btn>
          <b-btn class="btn-info mr-1 float-right btn-sm" disabled v-else>
              <b-spinner small type="grow"/>Loading...
            </b-btn>
          <b-btn class="btn-danger mr-1 float-right btn-sm" @click="closemodalku">Tutup</b-btn>
    </b-modal>
</div>

</template>

<script>
import { API_SERVER } from "@/config";
import { CALLAPI, CALLAPILOGIN } from "@/functions";
export default {
  name: 'DataKategori',
  data() {
    return {
      kategori:{
        nama:"",
        status:""
      },
      data_kategori: [],
      errors:[],
      loadingpost:false,
      modalstatus:"",
      readonly:{
        id:""
      }
    };
  },
  mounted(){
  this.getdatakategori();
  },
  methods:{
    getdatakategori(){
    CALLAPI.get("kategori/?per_page=99")
      .then(response => {
        this.data_kategori = response.data.data;
        console.log(response);
      })
      .catch(e => {
        // this.$router.push({ path: "/user/404" })
        this.errors.push(e);
      });
    },
     showmodalku(status) {
      this.modalstatus=status;
      this.$refs.modal.show();
    },closemodalku() {
      this.resetdata();
      this.$refs.modal.hide();
    },resetdata(){
      this.kategori.nama="";
      this.kategori.status="";
    },
    addpost(){
      console.log(this.kategori);
      if(this.kategori.nama!="" && this.kategori.status!=""){
        this.loadingpost=true;
        let PushData;
        PushData = CALLAPI.post(`/kategori/add`, this.kategori);
        PushData.then(res => {
        this.getdatakategori()
        this.loadingpost=false;
        swal('Berhasil','Kategori Berhasil Dibuat','success',{
        buttons: true,
        timer: 3000,
        });
        this.closemodalku();
        // this.resetdata();        
        }).catch(e => {
          this.loadingpost=false;        
          swal('Error','Kategori Gagal Dibuat','error',{
          buttons: true,
          timer: 3000,
          });
          console.log(e.response ? e.response : e);
          this.closemodalku();

        });
        // this.resetdata();
      }else{
        this.loadingpost=false;
        swal('Error','Isi data dengan benar!','error',{
          buttons: true,
          timer: 3000,
          });
      }
      
    },
    viewdata(id){
      this.readonly.id=id;
      this.showmodalku("Ubah Data");
      CALLAPI.get("kategori/id/"+id)
      .then(response => {
        this.kategori = response.data.data;
        console.log(response);
      })
      .catch(e => {
        this.errors.push(e);
      });
    },
    updatepost(){
      if(this.kategori.nama!="" && this.kategori.status!=""){
      var id = this.readonly.id;
      this.loadingpost=true;
      // this.showmodalku("Ubah Data");
      CALLAPI.put("kategori/update/"+id,this.kategori)
      .then(response => {
        this.getdatakategori()
        this.closemodalku();
        swal('Berhasil','Kategori Berhasil Diubah','success',{
        buttons: true,
        timer: 3000,
        });
        this.loadingpost=false;
      })
      .catch(e => {
        this.errors.push(e);
        swal('Error','Kategori Gagal Diubah','error',{
          buttons: true,
          timer: 3000,
          });
          this.loadingpost=false;
      });
    }else{
        this.loadingpost=false;
        swal('Error','Isi data dengan benar!','error',{
          buttons: true,
          timer: 3000,
          });
        }
    },
    deletedata(id){
      swal({
          title: "Are you sure?",
          text: "Apakah Anda Yakin Ingin Menghapus Data ini?",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
            CALLAPI.delete("kategori/delete/"+id)
            .then(response => {
              this.getdatakategori()
              swal("Success Deleted","Berhasil Menghapus Data!", {
                icon: "success",
              });
            })
            .catch(e => {
              swal("Failed Deleted","Gagal Menghapus Data!", {
                icon: "error",
              });
              this.errors.push(e);
            });
            
          }
        });
    }
  }
}
</script>
